
import SignIn from '~/components/pages/SignIn.vue'

export default {
  name: 'PageLogin',
  components: { SignIn },
  auth: 'guest',
  layout: 'unauthenticated',
}
